import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import Swal from 'sweetalert2';
import {PageService} from '../../../page/services/page.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent implements OnInit {


  formData: FormData;
  archivos: any[] = [];
  filesDniComprador: any[] = [];
  filesDniVendedor: any[] = [];
  filesPadron: any[] = [];
  fileMandatoComprador: any[] = [];
  fileMandatoVendedor: any[] = [];
  filesCIFComprador: any[] = [];
  filesCIFVendedor: any[] = [];
  filesPoder: any[] = [];
  fileFicha: any[] = [];
  fileFactura: any[] = [];
  filePermiso: any[] = [];
  filesNRC: any[] = [];
  file05: any[] = [];
  file06: any[] = [];
  fileIva4: any[] = [];
  fileOtros: any[] = [];

  
  fileTitularidadCta: any[] = [];
  fileCenso: any[] = [];
  fileResidenciaFiscal: any[] = [];
  fileLicenciaTaxi: any[] = [];
  fileBaja: any[] = [];
  filePcAchatarrado: any[] = [];
  fileFtAchatarrado: any[] = [];
  fileIvtmAchatarrado: any[] = [];
  fileEscritura: any[] = [];
  fileExpedienteConsorcio: any[] = [];
  fileProforma: any[] = [];
  fileJustificantePago: any[] = [];
  fileContratoLeasing: any[] = [];
  fileMinimis: any[] = [];
  fileExpedienteAyudas: any[] = [];

  maxFileSize: number;
  sumFileSize = 0;
  maxSum: number;
  spinnerFirma = false;
  uploadProgress = 0;
  searchTerm = '';
  sectionExpanded: { [key: string]: boolean } = {
    tramite: true,
    ayudas: false,
  };

  constructor(public dialogRef: MatDialogRef<UploadFilesComponent>, private pageService: PageService,
              @Inject(MAT_DIALOG_DATA) public data: any,  private servicio: PageService) { }

  ngOnInit(): void {
    this.getUploadSize();
  }

  onFileDropped($event, numero): any {
    const ok = this.checkExtension($event);
    const size = this.checkSize($event[0]);

    if (!ok){
      Swal.fire('', 'Formato de archivo incorrecto, se admiten los siguientes' +
        ' archivos jpg, jpeg, png, pdf, jfif, doc, docx.', 'warning');
    }

    if (ok && size) {

      this.prepareFilesList($event, numero);
    }
  }

  getUploadSize(): void{
    this.servicio.getUploadSize().subscribe( async res => {
      await this.asignar(res);
    });
  }

  async  asignar(res): Promise<void>{
    this.maxSum =  res['maxUploadSize'];
    this.maxFileSize = res['maxFileSize'];
    console.log(this.maxSum, 'maxSum');
    console.log(this.maxFileSize, 'maxFileSize');
  }

  toggleSection(key: string): void {
    this.sectionExpanded[key] = !this.sectionExpanded[key];
  }

  effectiveExpanded(key: string): boolean {
    return this.sectionExpanded[key] || !!this.searchTerm;
  }

  fileBrowseHandler(files, numero): any {
    let i = 0;
    const arrFiles = Array.from(files);
    for (const file of files){
      const ok = this.checkSize(file);
      if ( !ok ){
        arrFiles.splice(i, 1);
      }
      i++;
    }
    if ( files.length !== 0 ){
      this.prepareFilesList(arrFiles, numero);
    }
  }

  checkExtension(file: Array<any>): boolean {
    const fileNombre = file[0].name.toLowerCase();
    const regex = new RegExp('(.*?)\.(jpg|jpeg|png|pdf|jfif|zip)$');
    return regex.test(fileNombre);
  }

  prepareFilesList(files: Array<any>, numero): any {
    this.archivos.push(files);
    if (numero === 0 && this.filesDniComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesDniComprador.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesDniComprador);
    }
    if (numero === 1 && this.filesDniVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesDniVendedor.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesDniVendedor);
    }
    if (numero === 2 && this.fileMandatoComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.fileMandatoComprador.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileMandatoComprador);
    }
    if (numero === 3 && this.fileMandatoVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.fileMandatoVendedor.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileMandatoVendedor);
    }
    if (numero === 4 && this.filesCIFComprador.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesCIFComprador.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesCIFComprador);
    }
    if (numero === 5 && this.filesCIFVendedor.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesCIFVendedor.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesCIFVendedor);
    }
    if (numero === 6 && this.filesPoder.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesPoder.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesPoder);
    }
    if (numero === 7 && this.fileFactura.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.fileFactura.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileFactura);
    }
    if (numero === 8 && this.fileFicha.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.fileFicha.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileFicha);
    }
    if (numero === 9 && this.filePermiso.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filePermiso.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filePermiso);
    }
    if (numero === 10 && this.filesPadron.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesPadron.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesPadron);
    }
    if (numero === 11 && this.filesNRC.length < 2) {
      for (const item of files) {
        item.progress = 0;
        this.filesNRC.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.filesNRC);
    }
    if (numero === 12) {
      for (const item of files) {
        item.progress = 0;
        this.file05.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.file05);
    }
    if (numero === 13) {
      for (const item of files) {
        item.progress = 0;
        this.file06.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.file06);
    }
    if (numero === 14) {
      for (const item of files) {
        item.progress = 0;
        this.fileIva4.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileIva4);
    }
    if (numero === 15) {
      for (const item of files) {
        item.progress = 0;
        this.fileOtros.push(item);
        Array.from(files).forEach(f => {
          this.sumFileSize += f.size;
        });
      }
      this.uploadFilesSimulator(0, this.fileOtros);
    }

    if (numero === 58) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileTitularidadCta.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileTitularidadCta);
    }
    if (numero === 60) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileCenso.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileCenso);
    }
    if (numero === 61) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileResidenciaFiscal.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileResidenciaFiscal);
    }
    if (numero === 62) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileLicenciaTaxi.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileLicenciaTaxi);
    }
    if (numero === 63) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileBaja.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileBaja);
    }
    if (numero === 64) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.filePcAchatarrado.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.filePcAchatarrado);
    }
    if (numero === 65) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileFtAchatarrado.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileFtAchatarrado);
    }
    if (numero === 50) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileIvtmAchatarrado.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileIvtmAchatarrado);
    }
    if (numero === 51) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileEscritura.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileEscritura);
    }

    if (numero === 52) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileExpedienteConsorcio.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileExpedienteConsorcio);
    }

    if (numero === 53) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileProforma.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileProforma);
    }

    if (numero === 54) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileJustificantePago.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileJustificantePago);
    }

    if (numero === 55) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileContratoLeasing.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileContratoLeasing);
    }

    if (numero === 56) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileMinimis.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileMinimis);
    }

    if (numero === 57) {
      for (const item of files) {
        item.progress = 0;
        if (this.checkSize(item)) {
          this.fileExpedienteAyudas.push(item);
          Array.from(files).forEach((f) => {
            this.sumFileSize += f.size;
          });
        }
      }
      this.uploadFilesSimulator(0, this.fileExpedienteAyudas);
    }
  }


  uploadFilesSimulator(index: number, datos: Array<any>): any {
    setTimeout(() => {
      if (index === datos.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (!datos[index]) {
            clearInterval(progressInterval);
            return;
          }
          if (datos[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1, datos);
          } else {
            datos[index].progress += 50;
          }
        }, 100);
      }
    }, 600);
  }

  formatBytes(bytes, decimals?): any {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deleteFile(index: number, numero): any {
    const arr = this.getFilesArr(numero);
    if (!arr || !arr[index]) {
      return;
    }
    this.sumFileSize -= arr[index].size;
    arr.splice(index, 1);
  }

  private getFilesArr(numero: number): any[] | null {
    switch (numero) {
      case 0: return this.filesDniComprador;
      case 1: return this.filesDniVendedor;
      case 2: return this.fileMandatoComprador;
      case 3: return this.fileMandatoVendedor;
      case 4: return this.filesCIFComprador;
      case 5: return this.filesCIFVendedor;
      case 6: return this.filesPoder;
      case 7: return this.fileFactura;
      case 8: return this.fileFicha;
      case 9: return this.filePermiso;
      case 10: return this.filesPadron;
      case 11: return this.filesNRC;
      case 12: return this.file05;
      case 13: return this.file06;
      case 14: return this.fileIva4;
      case 15: return this.fileOtros;
      case 50: return this.fileIvtmAchatarrado;
      case 51: return this.fileEscritura;
      case 52: return this.fileExpedienteConsorcio;
      case 53: return this.fileProforma;
      case 54: return this.fileJustificantePago;
      case 55: return this.fileContratoLeasing;
      case 56: return this.fileMinimis;
      case 57: return this.fileExpedienteAyudas;
      case 58: return this.fileTitularidadCta;
      case 60: return this.fileCenso;
      case 61: return this.fileResidenciaFiscal;
      case 62: return this.fileLicenciaTaxi;
      case 63: return this.fileBaja;
      case 64: return this.filePcAchatarrado;
      case 65: return this.fileFtAchatarrado;
      default: return null;
    }
  }

  files(): any {
    this.formData = new FormData();
    this.filePermiso.forEach((item, i) => {
      this.formData.append('16-' + i, this.filePermiso[i]);
    });
    this.fileFicha.forEach((item, i) => {
      this.formData.append('17-' + i, this.fileFicha[i]);
    });
    this.file05.forEach((item, i) => {
      this.formData.append('18-' + i, this.file05[i]);
    });
    this.file06.forEach((item, i) => {
      this.formData.append('19-' + i, this.file06[i]);
    });
    this.filesCIFComprador.forEach((item, i) => {
      this.formData.append('27-' + i, this.filesCIFComprador[i]);
    });
    this.filesCIFVendedor.forEach((item, i) => {
      this.formData.append('28-' + i, this.filesCIFVendedor[i]);
    });
    this.fileFactura.forEach((item, i) => {
      this.formData.append('29-' + i, this.fileFactura[i]);
    });
    this.filesDniComprador.forEach((item, i) => {
      this.formData.append('30-' + i, this.filesDniComprador[i]);
    });
    this.filesDniVendedor.forEach((item, i) => {
      this.formData.append('31-' + i, this.filesDniVendedor[i]);
    });
    this.filesPadron.forEach((item, i) => {
      this.formData.append('32-' + i, this.filesPadron[i]);
    });
    this.fileMandatoComprador.forEach((item, i) => {
      this.formData.append('33-' + i, this.fileMandatoComprador[i]);
    });
    this.fileMandatoVendedor.forEach((item, i) => {
      this.formData.append('34-' + i, this.fileMandatoVendedor[i]);
    });
    this.filesPoder.forEach((item, i) => {
      this.formData.append('35-' + i, this.filesPoder[i]);
    });
    this.filesNRC.forEach((item, i) => {
      this.formData.append('36-' + i, this.filesNRC[i]);
    });
    this.fileIva4.forEach((item, i) => {
      this.formData.append('37-' + i, this.fileIva4[i]);
    });
    this.fileOtros.forEach((item, i) => {
      this.formData.append('38-' + i, this.fileOtros[i]);
    });
    
    this.fileTitularidadCta.forEach((item, i) => {
      this.formData.append('58-' + i, this.fileTitularidadCta[i]);
    });
    this.fileCenso.forEach((item, i) => {
      this.formData.append('60-' + i, this.fileCenso[i]);
    });
    this.fileResidenciaFiscal.forEach((item, i) => {
      this.formData.append('61-' + i, this.fileResidenciaFiscal[i]);
    });
    this.fileLicenciaTaxi.forEach((item, i) => {
      this.formData.append('62-' + i, this.fileLicenciaTaxi[i]);
    });
    this.fileBaja.forEach((item, i) => {
      this.formData.append('63-' + i, this.fileBaja[i]);
    });
    this.filePcAchatarrado.forEach((item, i) => {
      this.formData.append('64-' + i, this.filePcAchatarrado[i]);
    });
    this.fileFtAchatarrado.forEach((item, i) => {
      this.formData.append('65-' + i, this.fileFtAchatarrado[i]);
    });
    this.fileIvtmAchatarrado.forEach((item, i) => {
      this.formData.append('50-' + i, this.fileIvtmAchatarrado[i]);
    });
    this.fileEscritura.forEach((item, i) => {
      this.formData.append('51-' + i, this.fileEscritura[i]);
    });
    this.fileExpedienteConsorcio.forEach((item, i) => {
      this.formData.append('52-' + i, this.fileExpedienteConsorcio[i]);
    });
    this.fileProforma.forEach((item, i) => {
      this.formData.append('53-' + i, this.fileProforma[i]);
    });
    this.fileJustificantePago.forEach((item, i) => {
      this.formData.append('54-' + i, this.fileJustificantePago[i]);
    });
    this.fileContratoLeasing.forEach((item, i) => {
      this.formData.append('55-' + i, this.fileContratoLeasing[i]);
    });
    this.fileMinimis.forEach((item, i) => {
      this.formData.append('56-' + i, this.fileMinimis[i]);
    });
    this.fileExpedienteAyudas.forEach((item, i) => {
      this.formData.append('57-' + i, this.fileExpedienteAyudas[i]);
    });
  }


  guardar(): void {
    if (this.maxSum < this.sumFileSize){
      Swal.fire({
        icon: 'error',
        html:
          'El tamaño total de los archivos no debe ser superior a <u>' + this.formatBytes(this.maxSum) + '</u>.' ,
        confirmButtonColor: '#5A1727',
        confirmButtonText:
          'Aceptar',
      });
      return;
    }
    this.files();
    console.log(this.data);
    this.formData.append('id', this.data.id);
    this.spinnerFirma = true;
    this.uploadProgress = 0;

    const onSuccess = () => {
      this.spinnerFirma = false;
      this.uploadProgress = 0;
      Swal.fire('', 'Los archivos se han subido con éxito', 'success');
      this.dialogRef.close();
    };

    const onError = (error: any) => {
      this.spinnerFirma = false;
      this.uploadProgress = 0;
      console.log(error);
      Swal.fire('', 'Ha ocurrido un error, inténtelo de nuevo más tarde', 'warning');
    };

    const handleEvent = (event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        const total = event.total || event.loaded || 1;
        this.uploadProgress = Math.round((100 * event.loaded) / total);
      } else if (event.type === HttpEventType.Response) {
        onSuccess();
      }
    };

    if ( this.data.solictud ){
      this.pageService.addFilesToSolicitud(this.formData).subscribe(handleEvent, onError);
    } else {
      this.pageService.addFilesToExpediente(this.formData).subscribe(handleEvent, onError);
    }



  }
  checkSize(file): boolean {

    if (file.size > this.maxFileSize){

      Swal.fire({

        icon: 'error',

        html:
          'Nombre: ' + '<b>' + file.name + '</b> Tamaño: <b>' + this.formatBytes(file.size) + '</b> <br>' +
          'El archivo no debe superar los <u>'+this.maxFileSize+'</u>.' ,
        confirmButtonColor: '#5A1727',
        confirmButtonText:
          'Aceptar',
      });
      return false;
    }


    return  true;
  }


}
